let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fcTqx")).then(() => parcelRequire('3qZZA'));